<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Submit Hour</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />

        <div class="vx-row p-5" v-if="submitHourDescription.campaign_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Campaign Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ submitHourDescription.campaign_name }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="submitHourDescription.campaign_code">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Campaign Code:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ submitHourDescription.campaign_code }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="submitHourDescription.sales_devloper_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Sales Developer:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ submitHourDescription.sales_devloper_name }}
          </div>
        </div>
                <div class="vx-row p-5" v-if="submitHourDescription.campaign_code">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Date:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ submitHourDescription.date }}
          </div>
        </div>
                <div class="vx-row p-5" v-if="submitHourDescription.hours">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Hour:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ submitHourDescription.hours }}
          </div>
        </div>
        <template v-if="user_role != 'Sales Developer'">
          <div class="vx-row p-5" v-if="submitHourDescription.client_billable_hours">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Client Billable Hours:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ submitHourDescription.client_billable_hours }}
          </div>
        </div>
        </template>
    
                <div class="vx-row p-5" v-if="submitHourDescription.comments">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Comments:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ submitHourDescription.comments }}
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import axios from "@/axios.js";
import _ from "lodash";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
      user_id:null,
      user_role:null,
      authorized:true,
                              abilities : null,

      submitHourDescription: [],
    };
  },
  components: {
    "v-select": vSelect
  },
  created() {
     var self = this
     let userInfo = JSON.parse(localStorage.getItem("userInfo"));
     this.user_id = userInfo["uid"];
     this.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    }); 
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (this.user_role == 'Client Administrator' || this.user_role == 'Client'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }

    // this.checkSalesDeveloperCampaignPermission()

  },
  mounted() {
    if(this.authorized){
      this.init();
    }
  },
  methods: {
    checkSalesDeveloperCampaignPermission() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/checkSalesDeveloperCampaignPermission" , data)
        .then(res => {
          let result = res.data
          if (!result){
            this.authorized = false
            this.$router.replace("/unauthorized")
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    init() {
      const campaignSubmitHourId = this.$route.params.submitId;
      this.$store
        .dispatch("campaignsManagement/fetchSubmitHourById", campaignSubmitHourId)
        .then(res => {
          this.submitHourDescription = JSON.parse(res.data);
                    this.submitHourDescription =  this.submitHourDescription[0]

    })
    },
    goBack: function() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
